module.exports = __webpack_public_path__ + "assets/img/item04.7edf0c07.svg";